"use client";

import { usePdpCheapestOffer } from "@/lib/react-query/queries/accommodation/use-pdp-prices";

export function PdpBaseCapacity({
  accommodationId,
}: {
  accommodationId: string;
}) {
  const { isPending, offer } = usePdpCheapestOffer(accommodationId);

  if (isPending) return "--";

  return <>{offer?.baseCapacity ?? "--"}</>;
}
